export default {
      id: "customer-service-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#customer-service",
      toString: function () {
        return this.url;
      }
    }